export { default } from './AppContent';
